export { default } from './AppContent';
